import request from "@/utils/request";

const platformApi = {
  getPlatformInfo: (data) =>
    request.sendRequest({
      METHOD_NAME: "user.getPlatformInfo",
      SECURITY_TYPE: "None",
      data,
      ERROR_CODE: {},
    }),
};

export default platformApi;
